module.exports = __webpack_public_path__ + "img/Dashboard.f1debc0e.png";